<template>
    <div>
      <!--PC端-->
      <div>
        
        <router-view></router-view>
       
      </div>

      <!--移动端-->
      <div hidden>
        <!--底部导航-->
        <tabbar :selected="selected" :tabs='tabs'></tabbar>
      </div>

    </div>
</template>

<script>
  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import '@/assets/css/index.css'
  import {getCookie,setCookie} from "../../util/util";

  export default {
    name: "mine",
    data(){
      return {

        advertiseList:[],
        selected:"Mine",
        tabs:[
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        limit:10,
        page:1,
        orderList:[],
        user:{},
        p_showSearch:true,
        p_loginModalFlag:false,
        userList:[]
      }
    },
    components:{
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread,
    },
    methods: {
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },
    }
  }
</script>

<style scoped>

  .userInfo{
    width:100%;
    height:150px;
    margin-top:20px;

  }
  .userInfo .img_box{
    width: 40%;
    height: 100%;
    float: left;
  }
  .userInfo .img{
    width: 60px;
    height:60px;
    border-radius: 50%;
  }
  .userInfo .info_box{
    width: 60%;
    float: left;
  }
  .userInfo .info{
    display: block;
    height: 40px;
    line-height: 40px;
    text-align :left;
  }
  .el-menu-item.is-active{
    color: #00C5B0;
  }



</style>



// WEBPACK FOOTER //
// src/pages/user/Mine.vue